import React from "react";
import { CheckCircle2 } from "lucide-react";
import LpCta from "./LpCta";
import { DIFERENCIAIS } from "./lpData";

const LpDiferenciais = () => (
  <section className="section-pad bg-white" data-testid="lp-diferenciais">
    <div className="aevos-container grid lg:grid-cols-12 gap-12">
      <div className="lg:col-span-5">
        <h2 className="font-display font-bold text-3xl md:text-5xl leading-[1.08]">
          Um cuidado que considera o que acontece entre uma consulta e outra
        </h2>
        <p className="mt-6 font-display font-medium text-black text-base md:text-lg border-l-2 border-[#00C4FF] pl-5">
          Você participa das decisões e entende o motivo de cada orientação.
        </p>
        <div className="mt-10 hidden lg:block">
          <LpCta location="diferenciais">Quero conhecer esse acompanhamento</LpCta>
        </div>
      </div>

      <ul className="lg:col-span-7 grid sm:grid-cols-2 gap-4" data-testid="lp-diferenciais-list">
        {DIFERENCIAIS.map((d) => (
          <li key={d} className="aevos-card p-6 flex gap-3 items-start">
            <CheckCircle2 size={20} className="text-[#00C4FF] mt-0.5 flex-shrink-0" />
            <span className="text-[#333333] text-sm md:text-base leading-relaxed">{d}</span>
          </li>
        ))}
      </ul>

      <div className="lg:hidden">
        <LpCta location="diferenciais-mobile">Quero conhecer esse acompanhamento</LpCta>
      </div>
    </div>
  </section>
);

export default LpDiferenciais;
